import React from "react";
import { useMediaQuery } from "@mui/material";
import Main from "./Desktop-View/Main";
import MobileMain from "./Mobile-View/MobileMain";

const RenderView = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return isMobile ? <MobileMain /> : <Main />;
};

export default RenderView;
